// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"116":"graphs","341":"modals","821":"eventlog","942":"admin-tools"}[chunkId] + "." + {"116":"b33cc761","341":"a79aebf1","821":"29d2e85e","942":"c9bb338e"}[chunkId] + ".css";
};